import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.locked = false;
    this.paymentInProgress = false;
    this.queuedTip = null;

    this.appliedTipAmount = 0;
    this.appliedProcessingFeeHtml = $('.js-processing-fee').first().html();
    this.appliedPayTotalHtml = this.payButtons().first().find('.js-pay-total').html();

    this.onPaymentProcessing = () => {
      this.paymentInProgress = true;
      this.lockTipButtons();
      $('.js-other-tip-amount').prop('disabled', true);
    };

    this.onPaymentIdle = () => {
      this.paymentInProgress = false;
      this.unlockTipButtons();
      $('.js-other-tip-amount').prop('disabled', false);
    };

    document.addEventListener('bp:payment-processing', this.onPaymentProcessing);
    document.addEventListener('bp:payment-idle', this.onPaymentIdle);
  }

  disconnect() {
    document.removeEventListener('bp:payment-processing', this.onPaymentProcessing);
    document.removeEventListener('bp:payment-idle', this.onPaymentIdle);
  }

  setFixedTipAmount(event) {
    event.preventDefault();
    if (this.locked) return;

    this.markActive(event.currentTarget);
    this.lockTipButtons();
    $('.js-select-other-tip-amount').hide();

    var tipAmount = Number($(event.currentTarget).find('.js-tip-amount').val());
    this.setTipAmount(tipAmount);
  }

  setOtherTipAmount(event) {
    if (this.paymentInProgress) return;

    var otherTipAmount = Number($(event.target).val());
    var controller = this;

    window.currentOtherTipAmount = otherTipAmount;

    setTimeout(() => {
      if(otherTipAmount == window.currentOtherTipAmount) {
        if (controller.locked) {
          controller.queuedTip = otherTipAmount;
        } else {
          controller.setTipAmount(otherTipAmount);
        }
      }
    }, 250);

    event.preventDefault();
  }

  showOtherTipAmountField(event) {
    event.preventDefault();
    if (this.locked) return;

    this.markActive(event.currentTarget);
    $('.js-other-tip-amount').val(this.appliedTipAmount > 0 ? this.appliedTipAmount : '');
    $('.js-select-other-tip-amount').show();
  }

  markActive(target) {
    $(this.element).find('.btn').removeClass('active');
    $(target).addClass('active');
  }

  lockTipButtons() {
    this.locked = true;
    $(this.element).find('.btn').addClass('disabled');
  }

  unlockTipButtons() {
    if (this.paymentInProgress) return;

    this.locked = false;
    $(this.element).find('.btn').removeClass('disabled');
  }

  payButtons() {
    return $('#card-button, #stripe-submit-button');
  }

  setTipAmount(tipAmount) {
    this.lockTipButtons();

    var baseTotal = Number($('.js-total').data('total'));
    var tipValue = $('.js-tip-value');
    var currencyUnit = tipValue.data('currencyUnit');

    // Processing amount
    var newTotal = tipAmount + baseTotal;

    if(tipAmount > 0){
      $('.js-tip-amount').show();
    } else {
      $('.js-tip-amount').hide();
    }

    tipValue.html(currencyUnit + tipAmount.toFixed(2));
    this.payButtons().prop('disabled', 'disabled');

    $('.js-processing-fee').html('-');

    this.updatePaymentIntent(tipAmount);
  }

  updatePaymentIntent(tipAmount){
    if($('#stripe-submit-button').is('*')){
      var paymentIntentId = $('#stripe-submit-button').data('paymentIntentId');
    } else {
      var paymentIntentId = $('#card-button').data('paymentIntentId');
    }

    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
    var paramsObj = {
      payment_intent_id: paymentIntentId,
      tip: tipAmount
    };

    params.forEach((value, key) => {
      paramsObj[key] = value;
    });

    var controller = this;

    $.ajax({
      url: window.updatePaymentIntentUrl,
      type: "POST",
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', localStorage.getItem("bp-x-csrf-token"));
      },
      data: paramsObj,
      dataType: 'json',
      success: function(data) {
        if (data['success'] !== true) {
          controller.revertTipSelection(data['error_message']);
          return;
        }

        var tipValue = $('.js-tip-value');
        var currencyUnit = tipValue.data('currencyUnit');

        controller.appliedTipAmount = tipAmount;
        controller.appliedProcessingFeeHtml = currencyUnit + Number(data['processing_fee']).toFixed(2);
        controller.appliedPayTotalHtml = ' ' + currencyUnit + Number(data['display_total']).toFixed(2);

        $('#card-result').text('');
        $('#card-button').data('tip', tipAmount.toFixed(2));
        $('.js-processing-fee').html(controller.appliedProcessingFeeHtml);
        controller.payButtons().find('.js-pay-total').html(controller.appliedPayTotalHtml);

        if (!controller.paymentInProgress) {
          controller.payButtons().prop('disabled', false);
        }

        controller.unlockTipButtons();
        controller.flushQueuedTip();
      },
      error: function(xhr) {
        var errorMessage = xhr.responseJSON && xhr.responseJSON['error_message'];
        controller.revertTipSelection(errorMessage);
      }
    });

  }

  revertTipSelection(errorMessage) {
    var appliedTip = this.appliedTipAmount;
    var tipValue = $('.js-tip-value');
    var currencyUnit = tipValue.data('currencyUnit');

    $('#card-result').text(errorMessage || "We couldn't update your tip. Please try again.");

    $(this.element).find('.btn').removeClass('active');
    $('.js-select-other-tip-amount').hide();

    var matchingRadio = $(this.element).find('.js-tip-amount').filter(function() {
      return Number($(this).val()) === appliedTip;
    }).first();

    if (matchingRadio.length) {
      matchingRadio.closest('.btn').addClass('active');
    } else if (appliedTip > 0) {
      $(this.element).find('input[value="Other"]').closest('.btn').addClass('active');
      $('.js-other-tip-amount').val(appliedTip);
      $('.js-select-other-tip-amount').show();
    }

    tipValue.html(currencyUnit + appliedTip.toFixed(2));

    if (appliedTip > 0) {
      $('.js-tip-amount').show();
    } else {
      $('.js-tip-amount').hide();
    }

    $('.js-processing-fee').html(this.appliedProcessingFeeHtml);
    this.payButtons().find('.js-pay-total').html(this.appliedPayTotalHtml);
    $('#card-button').data('tip', appliedTip.toFixed(2));

    if (!this.paymentInProgress) {
      this.payButtons().prop('disabled', false);
    }

    this.unlockTipButtons();
    this.flushQueuedTip();
  }

  flushQueuedTip() {
    var queued = this.queuedTip;
    this.queuedTip = null;

    if (queued == null || this.paymentInProgress) return;
    if (queued === this.appliedTipAmount) return;

    this.setTipAmount(queued);
  }
}
